"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSafeTechCollectorInfo = exports.fetchPaymentExperience = exports.fetchPaymentMethod = void 0;
const browser_monads_1 = require("browser-monads");
const fluture_1 = require("fluture");
const config_1 = require("../config");
const errorLogging_1 = require("../thirdparty/errorLogging");
const ecommApi_1 = require("./ecommApi");
/**
 * Generate a new payment signature in Zuora and return the newly created payment method for rendering the payment form.
 *
 * Currently, this only supports generating an anonymous signature.
 */
const fetchPaymentMethod = () => (handleFailure) => (handleSuccess) => {
    const options = buildFetchOptions('POST', {
        clientType: config_1.paymentsPageType,
        // eslint-disable-next-line -- browser-monads isn't typed and needs to be switched to browser-monads-ts
        origin: browser_monads_1.window.location.origin
    });
    const url = `${config_1.paymentsApiUrl}/v1/credit/methods`;
    (0, ecommApi_1.attemptApiRequest)(url, options)
        .pipe((0, fluture_1.fork)((e) => {
        (0, errorLogging_1.logError)(e);
        handleFailure && handleFailure(e);
    })(handleSuccess));
};
exports.fetchPaymentMethod = fetchPaymentMethod;
/**
 * Fetch the payment experience name for anonymous users or logged-in users.
 */
const fetchPaymentExperience = (request) => (handleFailure) => (handleSuccess) => {
    const options = buildFetchOptions('POST', request);
    const url = `${config_1.paymentsApiUrl}/v1/credit/experience`;
    (0, ecommApi_1.attemptApiRequest)(url, options)
        .pipe((0, fluture_1.fork)((e) => {
        (0, errorLogging_1.logError)(e);
        handleFailure && handleFailure(e);
    })(handleSuccess));
};
exports.fetchPaymentExperience = fetchPaymentExperience;
/**
 * Fetch the SafeTech Data Collector SDK information.
 */
const fetchSafeTechCollectorInfo = (request) => (handleFailure) => (handleSuccess) => {
    const options = buildFetchOptions('GET');
    const queryParams = new URLSearchParams({ sessionId: request.sessionId || '' });
    const url = `${config_1.paymentsApiUrl}/v1/safetech/collector/${request.domain}?${queryParams.toString()}`;
    (0, ecommApi_1.attemptApiRequest)(url, options)
        .pipe((0, fluture_1.fork)((e) => {
        (0, errorLogging_1.logError)(e);
        handleFailure && handleFailure(e);
    })(handleSuccess));
};
exports.fetchSafeTechCollectorInfo = fetchSafeTechCollectorInfo;
const buildFetchOptions = (method, body) => ({
    body: body ? JSON.stringify(body) : null,
    method
});
//# sourceMappingURL=paymentsClient.js.map